module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-12-14ce998f8086c01d9d9ad7c5fb5853ee.png";